import { Game } from '../types/plugin'
import { z } from 'zod'
import type { BgioGameLogic } from '@merels/sdk'

/**
 * Converts a boardgame.io game definition to our Game interface
 */
export function createBgioGameWrapper(gameLogic: BgioGameLogic): Game {
  // Create a minimal Zod schema for moves (bgio games handle validation themselves)
  const moveSchema = z.object({
    type: z.string(),
  }).passthrough() // Allow additional properties

  const { bgioGame, encodeMove, decodeMove } = gameLogic
  if (!bgioGame.name) {
    throw new Error('`gameLogic.bgioGame.name` is required')
  }

  return {
    name: bgioGame.name,
    moveSchema,
    // These are required by the interface but won't be used for bgio games
    getInitialGameState: () => {
      throw new Error('Use bgio game engine instead')
    },
    applyMove: () => {
      throw new Error('Use bgio game engine instead')
    },
    // bgio-specific fields
    bgioGameDef: bgioGame,
    isBgio: true,
    // Optional move presentation is a Merels concern, not part of the Boardgame.io game type.
    encodeMove,
    decodeMove,
  }
}
